var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCardAccountRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 388,
    height: 246,
    viewBox: "0 0 388 246",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M387.834 23.2077V222.3C387.834 235.111 377.436 245.508 364.626 245.508H23.2077C10.3975 245.508 0 235.111 0 222.3V23.2077C0 10.3975 10.3975 0 23.2077 0H364.637C369.221 0 373.507 1.33272 377.091 3.64201C383.548 7.74357 387.834 14.9816 387.834 23.2077Z",
    fill: "url(#paint0_linear_835_159)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M387.832 23.2078V174.38C351.354 188.213 310.235 183.548 300.251 165.981C292.933 153.102 307.857 143.061 303.709 119.302C301.733 108.042 296.552 99.8163 289.164 92.0497C279.272 81.6063 265.405 72.013 250.113 57.0543C240.279 47.438 216.175 23.8626 203.031 0H364.624C369.208 0 373.493 1.33272 377.09 3.6535C383.558 7.74358 387.832 14.9701 387.832 23.2078Z",
    fill: "url(#paint1_linear_835_159)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M387.832 75.609V222.3C387.832 235.111 377.446 245.497 364.636 245.497H23.206C10.3958 245.497 0.00976562 235.111 0.00976562 222.3V109.662C6.69636 103.045 14.5204 96.8522 23.6311 91.6362C51.4115 75.7009 78.2613 76.7694 130.823 79.5383C194.151 82.8701 198.609 93.7157 243.197 95.0943C261.545 95.6688 276.481 94.3131 289.165 92.0498C331.915 84.3177 348.85 65.9238 383.237 74.3452C384.765 74.7244 386.293 75.138 387.832 75.609Z",
    fill: "url(#paint2_linear_835_159)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M119.474 0C113.155 61.6844 62.569 110.26 0 113.442V23.2078C0 10.3975 10.3975 0 23.2078 0H119.474Z",
    fill: "url(#paint3_linear_835_159)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M287.888 245.496H124.756L195.229 175.023C201.33 168.934 211.302 168.934 217.403 175.023L287.888 245.496Z",
    fill: "url(#paint4_linear_835_159)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.27,
    d: "M387.834 219.578V222.289C387.834 235.099 377.436 245.497 364.626 245.497H23.2077C10.3975 245.497 0 235.099 0 222.289V130.998C6.43383 127.574 13.8672 124.966 22.1967 124.047C41.4982 121.944 56.6407 129.987 74.4256 139.718C108.536 158.387 113.902 173.151 133.192 185.421C170.301 209.031 200.793 186.467 263.776 188.029C311.225 189.224 361.616 203.7 387.834 219.578Z",
    fill: "url(#paint5_linear_835_159)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.53,
    d: "M387.834 23.2077V222.3C387.834 235.111 377.436 245.508 364.626 245.508H23.2077C10.3975 245.508 0 235.111 0 222.3V23.2077C0 10.3975 10.3975 0 23.2077 0H364.637C369.221 0 373.507 1.33272 377.091 3.64201C383.548 7.74357 387.834 14.9816 387.834 23.2077Z",
    fill: "url(#paint6_linear_835_159)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M64.9596 157.916H33.9393C31.9518 157.916 30.3203 156.285 30.3203 154.297V131.331C30.3203 129.343 31.9518 127.712 33.9393 127.712H64.9596C66.9472 127.712 68.5787 129.343 68.5787 131.331V154.297C68.5787 156.285 66.9472 157.916 64.9596 157.916Z",
    fill: "#F6C859"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M45.0352 153.884C44.8744 153.884 44.7135 153.792 44.6446 153.643C44.5297 153.425 44.6216 153.16 44.8399 153.045C45.4833 152.712 46.3564 152.103 46.862 151.035C47.5053 149.679 47.333 148.209 47.0688 148.082C46.9998 148.048 46.7356 148.186 46.5747 148.266C46.1611 148.484 45.5752 148.772 44.9088 148.542C44.254 148.312 43.9323 147.726 43.7829 147.45C42.7834 145.612 42.4732 140.833 43.5301 138.454C43.8863 137.662 44.3574 137.202 44.9548 137.064C45.5637 136.926 46.0577 137.179 46.4484 137.386C46.77 137.558 46.9424 137.627 47.0343 137.57C47.4479 137.317 47.4364 135.8 46.862 134.594C46.3564 133.526 45.4833 132.917 44.8399 132.584C44.6216 132.469 44.5412 132.204 44.6446 131.986C44.7595 131.768 45.0237 131.687 45.242 131.791C46.0003 132.181 47.0458 132.917 47.6547 134.215C48.2636 135.49 48.5508 137.685 47.4824 138.328C46.9424 138.65 46.4369 138.385 46.0233 138.179C45.7131 138.018 45.4258 137.868 45.1386 137.937C44.748 138.029 44.4837 138.477 44.3229 138.834C43.3923 140.902 43.6565 145.428 44.5412 147.048C44.6905 147.324 44.8744 147.623 45.1846 147.726C45.4833 147.829 45.759 147.703 46.1611 147.496C46.5518 147.301 46.9883 147.071 47.4479 147.301C48.4359 147.783 48.3785 149.92 47.6547 151.437C47.0458 152.724 46.0003 153.47 45.242 153.861C45.1731 153.873 45.1041 153.884 45.0352 153.884Z",
    fill: "#7D662D"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M43.7164 139.258H35.743C35.5017 139.258 35.2949 139.063 35.2949 138.81C35.2949 138.558 35.4902 138.362 35.743 138.362H43.7164C43.9576 138.362 44.1644 138.558 44.1644 138.81C44.1644 139.063 43.9576 139.258 43.7164 139.258Z",
    fill: "#7D662D"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M43.7164 147.243H35.743C35.5017 147.243 35.2949 147.048 35.2949 146.795C35.2949 146.542 35.4902 146.347 35.743 146.347H43.7164C43.9576 146.347 44.1644 146.542 44.1644 146.795C44.1644 147.048 43.9576 147.243 43.7164 147.243Z",
    fill: "#7D662D"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M54.3429 153.884C54.2739 153.884 54.205 153.873 54.1361 153.838C53.3778 153.447 52.3323 152.712 51.7234 151.414C50.9996 149.897 50.9421 147.76 51.9302 147.278C52.3897 147.06 52.8263 147.278 53.2169 147.473C53.619 147.68 53.8948 147.806 54.1935 147.703C54.5267 147.588 54.722 147.232 54.8369 147.025C55.7215 145.405 55.9858 140.89 55.0552 138.811C54.8943 138.454 54.6186 138.006 54.2394 137.914C53.9982 137.857 53.8488 137.616 53.9063 137.386C53.9637 137.145 54.205 137.007 54.4348 137.053C55.0322 137.191 55.5032 137.662 55.8594 138.454C56.9164 140.833 56.6177 145.612 55.6066 147.45C55.4573 147.726 55.1356 148.312 54.4807 148.542C53.8144 148.771 53.2284 148.484 52.8148 148.266C52.654 148.186 52.3782 148.048 52.3208 148.082C52.0565 148.209 51.8842 149.679 52.5276 151.035C53.0331 152.103 53.9063 152.712 54.5497 153.045C54.7679 153.16 54.8484 153.425 54.745 153.643C54.6645 153.792 54.5037 153.884 54.3429 153.884Z",
    fill: "#7D662D"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M52.5727 137.489C52.3888 137.489 52.2165 137.374 52.1476 137.191C51.194 134.341 53.4229 132.147 54.1352 131.779C54.3535 131.664 54.6177 131.756 54.7326 131.975C54.8475 132.193 54.7556 132.457 54.5373 132.572C54.2156 132.733 52.1706 134.491 52.9863 136.915C53.0667 137.145 52.9403 137.397 52.7105 137.478C52.6646 137.478 52.6186 137.489 52.5727 137.489Z",
    fill: "#7D662D"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M63.646 139.258H55.6727C55.4314 139.258 55.2246 139.063 55.2246 138.81C55.2246 138.558 55.4199 138.362 55.6727 138.362H63.646C63.8873 138.362 64.0941 138.558 64.0941 138.81C64.0941 139.063 63.8988 139.258 63.646 139.258Z",
    fill: "#7D662D"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M63.646 147.243H55.6727C55.4314 147.243 55.2246 147.048 55.2246 146.795C55.2246 146.542 55.4199 146.347 55.6727 146.347H63.646C63.8873 146.347 64.0941 146.542 64.0941 146.795C64.0941 147.048 63.8988 147.243 63.646 147.243Z",
    fill: "#7D662D"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_835_159",
    x1: 42.3855,
    y1: 274.286,
    x2: 345.452,
    y2: -28.7804,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#641414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8383"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_835_159",
    x1: 257.944,
    y1: 124.672,
    x2: 378.423,
    y2: 4.19325,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8383"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#641414"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_835_159",
    x1: 66.4032,
    y1: 298.301,
    x2: 338.462,
    y2: 26.2413,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#641414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8383"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_835_159",
    x1: -13.4315,
    y1: 100.007,
    x2: 103.023,
    y2: -16.448,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#641414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8383"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_835_159",
    x1: 165.541,
    y1: 286.281,
    x2: 247.104,
    y2: 204.719,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD0202"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8383"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_835_159",
    x1: 71.7366,
    y1: 303.637,
    x2: 271.816,
    y2: 103.559,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#641414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8383"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_835_159",
    x1: 42.3855,
    y1: 274.286,
    x2: 345.452,
    y2: -28.7804,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardAccountRed);
export default __webpack_public_path__ + "static/media/card_account_red.a7d06ba326636687e273e5c80f31f8a3.svg";
export { ForwardRef as ReactComponent };